import { Municipio } from "@/contexts/cadastro/municipio/model/Municipio";
import { api } from "@/shared/api/api";

export const createMunicipioApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<Municipio[]>("/municipios/todos", {
      headers,
    });
    return data;
  };

  return { listAll };
};
